import moment from 'moment';

export const dateFormatterForRequest = data => {
  const newDateArray = [];
  newDateArray[0] = Date.parse(moment(data.dateRange[0]).format('YYYY-MM-DD') + 'T00:00:00');
  newDateArray[1] = Date.parse(moment(data.dateRange[1]).format('YYYY-MM-DD') + 'T23:59:59');
  return { ...data, formattedDate: newDateArray };
};
